import type { FC } from 'react';
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormatDate } from '@pflegenavi/frontend/localization';
import { YEAR_MONTH_DAY_SHORT_FORMAT } from '@pflegenavi/shared/constants';

interface KycIdvCardViewProps {
  kycVerified: boolean;
  renewalDeadline: string | null;
  onOpenDialog: () => void;
}

export const KycIdvCardView: FC<KycIdvCardViewProps> = ({
  kycVerified,
  renewalDeadline,
  onOpenDialog,
}) => {
  const { t } = useTranslation();
  const formatDate = useFormatDate();

  return (
    <Card>
      <CardContent>
        <Stack
          sx={{
            gap: 1,
          }}
        >
          <Typography variant="h6">{t('kyc.idv.card.title')}</Typography>
          <Typography variant="body2">
            {kycVerified
              ? t('kyc.idv.kyc-status.verified')
              : t('kyc.idv.kyc-status.not-verified')}
          </Typography>
          {renewalDeadline && (
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
              }}
            >
              {t('kyc.idv.renewal-deadline', {
                date: formatDate(
                  new Date(renewalDeadline),
                  YEAR_MONTH_DAY_SHORT_FORMAT
                ),
              })}
            </Typography>
          )}
          <Stack direction="row">
            <Button variant="outlined" onClick={onOpenDialog}>
              {t('kyc.idv.open-dialog')}
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
